import type {
  IDatabaseResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabaseResponseInstance'
import type {
  IDatabaseViewResponseInstance,
} from '@toolify/server/src/controllers/DatabaseViewController/types/IDatabaseViewResponseInstance'

export function getDefaultDatabaseViewId(
  database: Pick<IDatabaseResponseInstance, 'defaultDatabaseViewId'>,
  databaseViews: Pick<IDatabaseViewResponseInstance, 'id' | 'position'>[],
): string | null {
  return databaseViews.find(view => view.id === database.defaultDatabaseViewId)?.id
    || databaseViews.find(view => view.position === 0)?.id
    || databaseViews[0]?.id
    || null
}
